// extracted by mini-css-extract-plugin
export default {"Container":"vQauhxC3","Bottom":"xiKGmiz1","PricingLayout":"lcLjcAm1","TotalPricing":"oiwnx9Xm","TotalPriceGroup":"qTPtyWq1","Separator":"OXOJRiSc"};